import GenericModelField from "./GenericModelField";
import { PersonTag } from "components/ui/atoms/Tag";
import ModelProvider from "models/ModelProvider";
import { usePeople, usePeopleAsync } from "models/people/apiPeople";
import CreatePeopleButton from "components/ui/atoms/CreatePeopleButton";

const PeopleField = ({ name, multiple, label, creatable }) => {
  const getPeopleAsync = usePeopleAsync({});

  return (
    <GenericModelField
      name={name}
      multiple={multiple}
      label={label}
      CreateButton={creatable && CreatePeopleButton}
      indexName="people"
      getOptionLabel={(option) => {
        return `${option.best_name} (${option.best_email_address})`;
      }}
      getObectFromIdAsync={(id) => {
        return getPeopleAsync(id);
      }}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.id}>
            {`${option.best_name} (${option.best_email_address})`}
          </li>
        );
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });

          return (
            <ModelProvider
              id={option.id}
              getter={usePeople}
              att_name="person"
              View={PersonTag}
              key={key}
              {...tagProps}
            />
          );
        });
      }}
    />
  );
};

export default PeopleField;
